export default {"src":"/_next/static/media/MAFlag.e91d882d.svg","height":480,"width":640};